import { useRef, FC, useCallback } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useForm, FormProvider, SubmitHandler } from 'react-hook-form';
import {
  generalInformationInitialFormValues,
  GeneralInformationValues,
} from './GeneralInformation';
import CampaignBookingApplication from '../../components/CampaignBookingApplication';
import {
  uploadingImageFormValues,
  UploadingImageValues,
} from './UploadingImage';
import { Helmet } from 'react-helmet';
import { useAction, useCityParam } from '../../hooks';
import { createInstitutionalCampaign } from '../../actions/videoActions';

export type WizardFormValues = GeneralInformationValues & UploadingImageValues;

const WizardForm: FC = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const { currentCityId } = useCityParam();
  const navigate = useNavigate();
  const useFormMethods = useForm<WizardFormValues>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      ...generalInformationInitialFormValues,
      ...uploadingImageFormValues,
    },
  });
  const { handleSubmit } = useFormMethods;
  const createInsitutionalCampaign = useAction(createInstitutionalCampaign);

  const handleOnSubmit: SubmitHandler<WizardFormValues> = useCallback(
    (data) => {
      const { name, fromDate, toDate, file } = data;
      const formData = new FormData();
      formData.append('image', file);
      formData.append('from_date', fromDate);
      formData.append('to_date', toDate);
      formData.append('name', name);

      createInsitutionalCampaign(currentCityId, formData).then(() => {
        navigate('/campagne');
      });
    },
    [createInsitutionalCampaign, currentCityId, navigate]
  );

  return (
    <FormProvider {...useFormMethods}>
      <form ref={formRef} onSubmit={handleSubmit(handleOnSubmit)}>
        <CampaignBookingApplication>
          <Helmet title="Comunicazione comunale" />

          <div style={{ maxWidth: '1080px', margin: '0 auto' }}>
            <Outlet />
          </div>
        </CampaignBookingApplication>
      </form>
    </FormProvider>
  );
};

export default WizardForm;
